import { z } from 'zod';
import * as t from 'Shared/model/basic';
import {genreKeys} from 'Shared/ArtistTypes';


export const connectionState = z.discriminatedUnion('state', [
	z.object({state: z.literal('unconnected')}),
	z.object({state: z.literal('emailed'), time: z.date(), artistName: z.string(), email: z.string()}),
	z.object({state: z.literal('connected'), artistId: t.id(), requestUpdate: z.date().optional()}),
]);

export const agreementState = z.discriminatedUnion('state', [
	z.object({state: z.literal('not sent')}),
	z.object({state: z.literal('offered'), time: z.date(), method: z.enum(['email','id']), agreementId: t.id()}),
	z.object({state: z.literal('accepted'), time: z.date(), agreementId: t.id()}),
]);

export type ConnectionState = z.infer<typeof connectionState>;
export type AgreementState = z.infer<typeof agreementState>;


/* Valid formats:
	https://www.facebook.com/watch/?v=10153949778421332
	https://www.facebook.com/abbemay/videos/2305474926170084/ 
 */
export const facebookVideoUrl = z.union([
	z.string().regex(/https?:\/\/www\.facebook\.com\/watch\/\?v=[0-9]+/),
	z.string().regex(/https?:\/\/www\.facebook\.com\/[^\/]+\/videos\/[0-9]+/)
]);			

/* Spotify also has artist and album urls */
export const spotifyTrackUrl = z.string().regex(/^https?:\/\/(?:[^\/]+\.|)spotify\.com\/track\/.+/);

export const appleUrl = z.string().regex(/^https?:\/\/(?:[^\/]+\.|)apple\.com\/.+/);

export const lineupSet = z.object({
	key: z.string(),
	setTime: t.time,
	name: z.string().max(200),
	mainGenre: genreKeys,
	otherGenre1: genreKeys,
	otherGenre2: genreKeys,
	extraGenre: z.string().max(100),
	tagline: z.string().max(200),
	biography: z.string().max(1000),
	country: z.string().max(100),
	state: z.string().max(8),
	city: z.string().max(100),
	musicEmbedPlatform: z.enum(['bandcamp','soundcloud']),
	musicEmbedId: z.string().max(32),
	videoEmbedPlatform: z.enum(['youtube','vimeo','facebookVideo']),
	videoEmbedId: z.string().max(32),
	facebookVideoUrl: facebookVideoUrl,
	spotify: spotifyTrackUrl,
	appleMusic: appleUrl,
	website: t.url,
	facebook: t.facebook,
	instagram: t.instagram,
	twitter: t.twitter,
	image: t.image,
	announceFacebookVideo:z.boolean(),

	/* Artist profile connection fields: */
	includeBookingOffer: z.boolean(),

	connectionState: connectionState,
	agreementState: agreementState,

	/* Kept during migration window — remove once migration 45 is confirmed complete: */
	artistId: t.id(),
	managerRequest: z.object({
		email: t.email,
		artistName: z.string(),
		time: z.date(),
	}),

	actModified: z.date(),
	lastCopy: z.date()
})
.strict()
.partial().required({
	key: true,
	actModified: true,
	lastCopy: true
});

export type LineupSet = z.infer<typeof lineupSet>;

export const lineup = z.array(lineupSet);

export type Lineup = z.infer<typeof lineup>;

